module.exports = __webpack_public_path__ + "static/media/vehicle-type-scooter-orange.3047030b.svg";